import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as d3 from 'd3';
import { CONFIG } from "../config";

export default function Recommendations({ selectedDate, selectedStatus, selectedAgeRange }) {

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  // Fetch data from API
  useEffect(() => {
    if (!selectedDate) return; // wait until selectedDate is available

    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${CONFIG.API_BASE_URL}/${CONFIG.RECOMMENDATIONS_URL}/${localStorage.getItem(
          "tensor-user-id"
        )}?date_str=${selectedDate}&selected_status=${selectedStatus}&selected_agerange=${selectedAgeRange}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("tensor-auth-token"),
          },
        });

        if (response.status === 401) {
          localStorage.removeItem('tensor-auth-token');
          localStorage.removeItem('tensor-user-id');
          navigate('/', { state: { message: 'Session expired please try again.', type: 'error' } });
          return;
        }

        const result = await response.json();
        if (result.success) {
          setData(result.data.recommendations);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error("Failed to fetch failures prevented data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDate, selectedStatus, selectedAgeRange]);

  return (
    <div className="w-full relative">
      {loading && (
        <div className="flex justify-center items-center min-h-[135px]">
          <svg className="w-6 h-6 text-blue-500 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"></circle>
            <path className="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z">
            </path>
          </svg>
        </div>
      )}


      {!loading && (
        <div className="min-h-[135px]">
          <p className="text-xl font-semibold mb-4 block_head">Recommendations by AI</p>
          <ul className="custom-list text-gray-600 space-y-2 ai_text">
            {data.map((item, index) => (
              <li key={index} style={{ textIndent: '-0.1rem' }}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>

  );
}
